import { UPDATE_ACTUAL_ITINERARY_SEGMENT } from "./actualItineraryPathSegmentReducer"

export const updateActualItinerarySegment = (value) => ({
    type: UPDATE_ACTUAL_ITINERARY_SEGMENT,
    payload: value
})